import { Link } from "react-router-dom";

export const Logo = ({ to = "/", testId = "logo" }) => (
  <Link to={to} data-testid={testId} className="font-logo text-[19px] font-semibold lowercase tracking-[-0.03em] text-ink">
    archijo
  </Link>
);

export const Flame = ({ className = "h-4 w-4" }) => (
  <svg viewBox="0 0 16 16" className={className} fill="none" aria-hidden="true">
    <path
      d="M8.2 1.5c.4 2.1-.6 3.3-1.7 4.5C5.4 7.2 4 8.5 4 10.4 4 12.7 5.8 14.5 8 14.5s4-1.8 4-4.1c0-1.6-.8-2.8-1.6-3.7-.2 1-.7 1.7-1.4 2 .5-2.9-.2-5.4-.8-7.2Z"
      fill="currentColor"
    />
  </svg>
);

export function Button({ variant = "primary", className = "", children, ...props }) {
  const base =
    "inline-flex items-center justify-center gap-2 rounded-full px-5 h-12 text-[15px] font-medium transition-[background-color,color,opacity,transform] duration-150 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-45 disabled:active:scale-100";
  const styles = {
    primary: "bg-accent text-on-accent hover:opacity-90",
    secondary: "bg-surface-2 text-ink hover:bg-line",
    ghost: "text-ink hover:bg-surface-2",
    outline: "border border-[color:color-mix(in_srgb,var(--text)_28%,transparent)] bg-transparent text-ink hover:bg-surface-2",
    danger: "bg-ink text-bg hover:opacity-90",
  };
  return (
    <button className={`${base} ${styles[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}

export const inputClass =
  "h-12 w-full rounded-card border border-line bg-surface-2 px-4 text-[16px] text-ink placeholder:text-muted outline-none transition-[border-color,background-color] duration-150 focus:border-accent focus:bg-surface";

export const Card = ({ className = "", children, ...props }) => (
  <div className={`rounded-card border border-line bg-surface ${className}`} {...props}>
    {children}
  </div>
);

export function Switch({ checked, onChange, testId, label }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      data-testid={testId}
      onClick={() => onChange(!checked)}
      className={`relative h-6 w-10 shrink-0 rounded-full transition-colors duration-200 ${checked ? "bg-accent" : "bg-line"}`}
    >
      <span
        className={`absolute top-0.5 h-5 w-5 rounded-full bg-surface transition-transform duration-200 ${checked ? "translate-x-[18px]" : "translate-x-0.5"}`}
      />
    </button>
  );
}
